module.exports = __webpack_public_path__ + "img/zs_5@2x.072fa0e0.png";